import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';
import Pagination from '../../Pagination/Paginations';
import EntriesSelector from '../../Pagination/EntriesSelector';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const RoleControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;


	const [user, setUser] = useState({
		menu_icon: "",
		menu_name: "",
		menu_type: "",
		menu_position: "",
		menu_link: ""
	})


	const history = useHistory();
	const [data, setData] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [roleres, setRoleRes] = useState([]);
	const [style1, setStyle1] = useState(false);

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setUser({ ...user, [name]: value });

		if (event.target.value === '1') {
			setIsVisible(true);
		} else {
			setIsVisible(false);
		}
	}









	useEffect(() => {
		axios.get(API_BASE_URL + '/fetchrole', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})

			// .then(res =>console.log(res.data))
			.then(res => setRoleRes(res.data))
			.catch(err => console.log(err));
	}, [])

	useEffect(() => {
		handleUpdate();
	}, []);



	const [currentPage, setCurrentPage] = useState(1);
	const [entriesPerPage, setEntriesPerPage] = useState(10);
	const [searchTerm, setSearchTerm] = useState("");

	const filteredRoles = roleres.filter((role) =>
		`${role.role_name || ""}`.toLowerCase().includes(searchTerm.toLowerCase())
	);

	const totalPages = Math.ceil(filteredRoles.length / entriesPerPage);
	const indexOfLast = currentPage * entriesPerPage;
	const indexOfFirst = indexOfLast - entriesPerPage;
	const currentData = filteredRoles.slice(indexOfFirst, indexOfLast);

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	const handleUpdate = async (id) => {

		axios.get(API_BASE_URL + '/showmenu/' + id, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})
			.then(res1 => setUser(res1.data))
			.catch(err => console.log(err))
	};


	const handleSubmit = async (e) => {

		e.preventDefault();
		// setError(null);
		// setLoading(true);
		//  e.preventDefault();

		console.log(user.menu_icon);
		axios.post(API_BASE_URL + '/addmenu', { menu_icon: user.menu_icon, menu_name: user.menu_name, menu_type: user.menu_type, menu_position: user.menu_position, menu_link: user.menu_link }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// 	console.log(response.data);
			// 	console.log(response.data.message);
			// })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				setTimeout(() => {
					return history.push("/hr-url");
				}, 3000);

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {
			// console.log(error);
			// console.log(error.response.data.message);




			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};



	const handleEditSubmit = (e) => {

		// console.log('hi');


		e.preventDefault();

		// console.log(user);
		// setError(null);
		// setLoading(true);
		// e.preventDefault();
		console.log(user);

		axios.post(API_BASE_URL + '/updatemenu', { menu_icon: user.menu_icon, menu_name: user.menu_name, menu_type: user.menu_type, menu_position: user.menu_position, menu_link: user.menu_link, id: user.id }, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}).then(response => {
			// 	console.log(response);
			// // 	console.log(response.data.message);
			//  })

			var status = response.data.status;

			if (status == 200) {
				toast.success(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});

				setTimeout(() => {
					return history.push("/hr-url");
				}, 3000);

			} else if (status == 401) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}
			else if (status == 400) {
				toast.error(response.data.message, {
					position: "bottom-right",
					autoClose: 5000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "colored",

				});
			}


		}).catch(error => {

			toast.error(error.response.data.message, {
				position: "bottom-right",
				autoClose: 5000,
				hideProgressBar: false,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "colored",


			});

		});
	};


	// const [globalFilterText,setGlobalFilterText]=useState();

	// const handleGlobalFilter=(e)=>{

	// 	const value= e.target.value || '';
	// 	setGlobalFilterText(value);

	// };

	// const filteredData=data.filter((row)=>{
	// return Object.values(row).some((value)=> value.toString().toLowerCase().includes(globalFilterText.toLowerCase())
	// );
	// }); 




	return (
		<>
			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>







					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">






										<div className="card-header">
											<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
												<i className="fa fa-user-circle mr-2" style={{ fontSize: "20px" }} />
												Role List
											</h3>
											<div className="card-options">
												<div style={{ display: "flex", alignItems: "center" }}>
													<EntriesSelector
														entriesPerPage={entriesPerPage}
														setEntriesPerPage={setEntriesPerPage}
														setCurrentPage={setCurrentPage}
													/>
													<div style={{ marginLeft: "15px" }}>
														<input
															type="text"
															className="form-control form-control-sm"
															style={{ width: "200px" }}
															placeholder="Search something..."
															value={searchTerm}
															onChange={(e) => setSearchTerm(e.target.value)}
														/>
													</div>
												</div>
											</div>
										</div>



										<div className="card-body">
											<div className="table-responsive sticky-table-wrap" style={{ maxHeight: "420px" }}>
												<table className="table table-hover table-striped  table-vcenter text-nowrap mb-0 sticky-table">
													<thead>
														<tr>
															<th>S.No</th>
															<th>Role Name</th>
															<th>Action</th>
														</tr>
													</thead>
													<tbody>
														{
															currentData.map((role, index) => {



																return <tr key={index}>
																	<td>
																		<span
																			className=""
																			data-toggle="tooltip"
																			data-original-title="Avatar Name"
																		>
																			{indexOfFirst + index + 1}
																		</span>

																	</td>
																	<td>
																		<span>{role.role_name}</span>
																	</td>








																	<td>



																		<Link to={`/hr-roleaccess?id=${role.role_id}`}>
																			<i className="fa fa-edit" />
																		</Link>

																	</td>
																</tr>
															})
														}

													</tbody>
												</table>
											</div>

											<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
											/>




										</div>
									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>


			<div
				className="modal fade"
				id="exampleEditModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit Menu
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
											<input type="text" className="form-control" name="menu_icon" value={user.menu_icon}
												onChange={handelInput} placeholder="Menu Icon" />

											<input name="menu_id" value={user.id} type="hidden" />

										</div>
									</div>

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
											<input type="text" className="form-control" name="menu_name" value={user.menu_name}
												onChange={handelInput} placeholder="Menu Name" />
										</div>
									</div>

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
											<input type="text" className="form-control" name="menu_position" value={user.menu_position}
												onChange={handelInput} placeholder="Position" />
										</div>
									</div>

									<div className="col-md-12 col-sm-12">
										<div className="form-group">
											<select name="menu_type" id="menu_type" className="form-control custom-select" value={user.menu_type} onChange={handelInput} >
												<option value="" disabled>Menu Type</option>
												<option value={1}>Direct Menu</option>
												<option value={2}>Sub Menu</option>
											</select>
										</div>
									</div>


									{user.menu_type == 1 || isVisible ? (

										<div className="col-md-12 col-sm-12">
											<select name="menu_link" id="menu_link" className="form-control custom-select" value={user.menu_link} onChange={handelInput}>
												<option value="" disabled>Select Menu Link</option>
												<option></option>
												{urlres.map(option => (
													<option key={option.id} value={option.id}>
														{option.link}
													</option>
												))}
											</select>
										</div>

									) : null}

								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Save changes
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>








		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleControl);